module.exports = __webpack_public_path__ + "static/media/medpal.8eee6abe.svg";